module.exports = __webpack_public_path__ + "img/download-icon.0e74fe44.svg";